import { EditorContent, useEditor } from '@tiptap/react'
import { useEffect } from 'react'
import { forumReaderExtensions } from '@/components/richtext/tiptap-extensions'
import { cn } from '@/lib/cn'

export function RichContent({ doc }: { doc: unknown }) {
  const editor = useEditor({
    extensions: forumReaderExtensions(),
    editable: false,
    immediatelyRender: false,
    content: doc as never,
  })

  useEffect(() => {
    if (!editor) return
    editor.commands.setContent(doc as never, false)
  }, [doc, editor])

  if (!editor) return <p className="text-[13px] text-nk-slate">Loading body…</p>

  return (
    <div
      className={cn(
        'nk-rich-body max-w-none text-[15px] leading-relaxed text-nk-navy',
        '[&_h1]:text-2xl [&_h1]:font-black [&_h1]:tracking-tight [&_h2]:text-xl [&_h2]:font-black [&_h2]:tracking-tight',
        '[&_h3]:text-lg [&_h3]:font-extrabold [&_h3]:tracking-tight',
        '[&_a]:text-nk-sea [&_a]:underline [&_a]:decoration-nk-sea/35 [&_a]:underline-offset-2',
        '[&_blockquote]:border-l-4 [&_blockquote]:border-nk-sea [&_blockquote]:bg-nk-sand/80 [&_blockquote]:py-0.5 [&_blockquote]:pl-3',
        '[&_code]:rounded [&_code]:bg-nk-sand [&_code]:px-1 [&_code]:text-[13px] [&_pre]:rounded-lg [&_pre]:border [&_pre]:border-nk-fog [&_pre]:bg-nk-navy [&_pre]:p-3 [&_pre]:text-[13px] [&_pre]:text-white',
        '[&_hr]:my-4 [&_hr]:border-0 [&_hr]:border-t-2 [&_hr]:border-nk-fog',
        '[&_ul]:list-disc [&_ul]:pl-5 [&_ol]:list-decimal [&_ol]:pl-5',
      )}
    >
      <EditorContent editor={editor} />
    </div>
  )
}
